import React from "react";
import { connect } from "react-redux";
import { AppState } from "reducers";
import { getDefaultRefinement } from "selectors/helpSelectors";

// Algolia + react-instantsearch documentation search removed in modernization.
// Kept as an inert component so the (now hidden) help modal still mounts cleanly.
type Props = {
  hitsPerPage: number;
  defaultRefinement: string;
  dispatch: any;
};

class DocumentationSearch extends React.Component<Props> {
  render() {
    return null;
  }
}

const mapStateToProps = (state: AppState) => ({
  defaultRefinement: getDefaultRefinement(state),
});

export default connect(mapStateToProps)(DocumentationSearch);
